import { animateScroll } from 'react-scroll';
import { mappedConst } from 'shared';

export const SCROLL_BEHAVIOR: mappedConst<ScrollBehavior> = {
  smooth: 'smooth',
  auto: 'auto',
};

const getElementOffsetTop = (element: HTMLElement) =>
  element.getBoundingClientRect().top + window.pageYOffset;

export const scrollAndFocus = (element: HTMLElement | null): void => {
  if (!element) {
    return;
  }
  const y = getElementOffsetTop(element);
  animateScroll.scrollTo(y, {
    smooth: 'easeOutQuad',
    duration: 300,
  });
  element.focus({ preventScroll: true });
};
